import React from 'react';
import { Link } from 'react-router-dom';
import { trackButtonClick } from '../../utils/analytics';
import SEO from '../SEO/SEO';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import ArticleCard from '../ArticleCard/ArticleCard';
import NewsletterSignup from '../NewsletterSignup/NewsletterSignup';
import articles from '../Articles/articles';
import categories from '../Categories/categories';
import '../Styles/reset.css';
import '../Styles/utils.css';
import '../Styles/layout.css';

function AllArticles() {
    const groupedArticles = {};

    categories.forEach(category => {
        groupedArticles[category.name] = articles.filter(
            article => article.category.toLowerCase() === category.name.toLowerCase()
        );
    });

    return (
        <div>
            <SEO
                title="All Health & Fitness Articles - SmartLifeChoice"
                description="Browse our complete collection of evidence-based health and fitness articles. Explore topics on nutrition, workouts, mental health, and wellness to guide your healthy lifestyle journey."
                url="/articles"
                keywords="health articles, fitness blog, nutrition guides, workout tips, mental health resources, wellness advice"
            />
            <Header />

            <main className="main">
                <div className="container">
                    <div style={{
                        padding: 'var(--space-4) 0',
                        borderBottom: '1px solid var(--color-gray-200)',
                        marginBottom: 'var(--space-4)'
                    }}>
                        <nav style={{ fontSize: '0.875rem', color: 'var(--color-gray-600)', marginBottom: 'var(--space-2)' }}>
                            <Link to="/home" style={{ color: 'var(--color-primary)', textDecoration: 'none' }}>Home</Link>
                            <span style={{ margin: '0 var(--space-2)' }}>/</span>
                            <span>All Articles</span>
                        </nav>
                        <h1 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: 'var(--space-2)' }}>
                            All Articles
                        </h1>
                        <p style={{ fontSize: '1.125rem', color: 'var(--color-gray-600)' }}>
                            Explore our complete collection of health and fitness articles organized by category
                        </p>
                    </div>

                    {categories.map((category) => {
                        const categoryArticles = groupedArticles[category.name] || [];

                        return (
                            <section key={category.id} id={category.slug} style={{ marginBottom: 'var(--space-6)' }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    marginBottom: 'var(--space-4)',
                                    paddingBottom: 'var(--space-3)',
                                    borderBottom: '2px solid var(--color-primary)'
                                }}>
                                    <h2 className="section-title" style={{ marginBottom: 0 }}>
                                        {category.name}
                                        <span style={{
                                            marginLeft: 'var(--space-2)',
                                            fontSize: '1rem',
                                            fontWeight: '400',
                                            color: 'var(--color-gray-600)'
                                        }}>
                                            ({categoryArticles.length} {categoryArticles.length === 1 ? 'article' : 'articles'})
                                        </span>
                                    </h2>
                                    <Link
                                        to={`/category/${category.slug}`}
                                        className="btn btn-outline"
                                        style={{ fontSize: '0.875rem', padding: '0.5rem 1rem' }}
                                        onClick={() => trackButtonClick('View Category', category.name)}
                                    >
                                        View Category
                                    </Link>
                                </div>

                                {categoryArticles.length === 0 ? (
                                    <div style={{
                                        padding: 'var(--space-6)',
                                        textAlign: 'center',
                                        backgroundColor: 'var(--color-gray-50)',
                                        borderRadius: 'var(--radius-lg)',
                                        color: 'var(--color-gray-600)'
                                    }}>
                                        <p style={{ fontSize: '1.125rem' }}>
                                            No articles in this category yet. Check back soon!
                                        </p>
                                    </div>
                                ) : (
                                    <div className="article-grid">
                                        {categoryArticles.map((article) => (
                                            <ArticleCard key={article.id} article={article} />
                                        ))}
                                    </div>
                                )}
                            </section>
                        );
                    })}
                </div>

                <NewsletterSignup />
            </main>

            <Footer />
        </div>
    );
}

export default AllArticles;
